<template>
    <div class="auxiliary-viewer">
        <!-- <img v-show="isStitched" class="no-smooth-crown-btn" v-on:click="switchNoSmoothCrown()"
            title="No smooth tooth crown"
            :src="app.isNoSmoothCrown ? 'images/crown_off_red.png' : 'images/crown_off_white.png'" /> -->
        <img class="auxiliary-layer-btn" :src="slicesVisible ? 'images/layer_red.png' : 'images/layer_white.png'"
            v-on:click="slicesVisibleChanged()" title="Show slices" />
        <img class="auxiliary-refresh-btn" src="images/refresh.png" v-on:click="refreshClick()" title="Refresh" />
        <div v-show="!app.selectedAnnotation.isNerve" class="input-group mb-2 mt-1 input-group-sm smooth-group">
            <span class="smooth-text">Smoothing:</span>
            <input v-model="smoothFactor" @change="smoothFactorChanged()" class="form-control-range smooth-input"
                type="range" min="1" max="100" step="1" />
        </div>
    </div>
</template>

<script>

import {
    initAuxilaryStlViewer, updateAuixiliaryMesh,
     smoothSelectedAnnotation, update3DSlices
} from "../AuxiliaryManager";

export default {
    name: "AuxiliaryViewer",
    data() {
        return {
            slicesVisible: false
        };
    },
    props: {
        app: {
            type: Object,
            required: true
        }
    },
    watch: {
        "app.selectedAnnotation.changed": {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    let annotation = this.app.selectedAnnotation;
                    // console.log(`${annotation.name} changed`, newVal);
                    // updateAuixiliaryMesh(annotation);
                }
            }
        },
    },
    mounted() {
        this.app.auxiliaryViewerId = this.app.divId + "_auxiliary_viewer";
        this.$el.setAttribute("id", this.app.auxiliaryViewerId);
        console.log("mounted " + this.app.auxiliaryViewerId);
        setTimeout(() => {
            initAuxilaryStlViewer(this, this.app);
        }, 100);
    },
    computed: {
        annotationSelected() {
            return !!this.app.selectedAnnotation;
        },
        smoothFactor: {
            get: function () {
                return this.app.selectedAnnotation ? this.app.selectedAnnotation.smoothFactor : 7;
            },
            set: function (value) {
                if (this.app.selectedAnnotation) {
                    this.app.selectedAnnotation.smoothFactor = +value;
                }
            }
        },
        isStitched() {
            return true;
        }
    },
    methods: {
        smoothFactorChanged: function () {
            smoothSelectedAnnotation();
        },
        switchNoSmoothCrown: function () {
            this.app.isNoSmoothCrown = !this.app.isNoSmoothCrown;
        },
        slicesVisibleChanged: function () {
            this.slicesVisible = !this.slicesVisible;
            update3DSlices(this.slicesVisible);
        },
        refreshClick: function () {
            console.log("refreshClick");
            let annotation = this.app.selectedAnnotation;
            updateAuixiliaryMesh(annotation);
        },
    }
};
</script>

<style scoped>
.auxiliary-viewer {
    background: #77a7fd;
    width: 100%;
    height: 100%;
}

.smooth-group {
    position: absolute;
    top: 3px;
    right: 3px;
    width: calc(50% + 25px);
}

.smooth-text {
    height: 27px !important;
    padding: 2px 4px !important;
    display: inline;
}

.smooth-input {
    display: inline;
    height: 27px;
    width: calc(100% - 92px);
    /* padding: 2px; */
}

.no-smooth-crown-btn {
    cursor: pointer;
    position: absolute;
    top: 6px;
    right: calc(50% + 30px);
    width: 25px;
    height: 25px;
    z-index: 99;
}

.auxiliary-layer-btn {
    cursor: pointer;
    position: absolute;
    top: 12px;
    left: 78px;
    width: 24px;
    height: 24px;
    z-index: 99;
}

.auxiliary-refresh-btn {
    cursor: pointer;
    position: absolute;
    top: 9px;
    left: 110px;
    width: 31px;
    height: 31px;
    z-index: 99;
}
</style>